import { Link } from 'react-router-dom';
import { AI_SATEI_URL, COMPANY } from '@/constants/company';

export default function CtaSection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/0bbc281867043d5475b2034c8accbbab.jpg"
          alt=""
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-[#0D1B2E]/88" />
      </div>
      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-12 text-center">
        <div className="flex items-center justify-center gap-3 mb-6">
          <div className="h-px w-10 bg-emerald-400" />
          <span className="text-emerald-400 text-xs font-semibold tracking-[0.2em] uppercase">Contact Us</span>
          <div className="h-px w-10 bg-emerald-400" />
        </div>
        <h2 className="text-white text-2xl md:text-4xl font-bold mb-4 leading-tight">
          まずは無料でご相談ください
        </h2>
        <p className="text-white/60 text-sm md:text-base mb-10 leading-relaxed">
          査定・相談は完全無料。押し売りは一切しません。<br />
          どんな小さなご質問でも、お気軽にどうぞ。
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href={AI_SATEI_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-3 bg-emerald-500 hover:bg-emerald-400 text-white px-8 py-4 rounded-full font-bold text-base whitespace-nowrap transition-all duration-300 cursor-pointer"
          >
            <i className="ri-calculator-line text-lg" />
            AI査定をはじめる（約60秒）
          </a>
          <a
            href={COMPANY.telHref}
            className="inline-flex items-center justify-center gap-3 border border-white/30 text-white px-8 py-4 rounded-full font-medium text-base whitespace-nowrap hover:bg-white/10 transition-all duration-300 cursor-pointer"
          >
            <i className="ri-phone-line" />
            電話でご相談
          </a>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-3 border border-white/30 text-white px-8 py-4 rounded-full font-medium text-base whitespace-nowrap hover:bg-white/10 transition-all duration-300 cursor-pointer"
          >
            <i className="ri-mail-line" />
            メールで相談
          </Link>
        </div>
      </div>
    </section>
  );
}